import { AllocateSingleId } from "../AllocateId";
import { GetMasterTableEntries } from "../GetMasterTableEntries";
import { DeleteFromServer, FetchFromServer, SaveToServer } from "../Post";

const MasterTableName = "GladianceUserRoles";
const FetchRequestType = "GladianceUserRoleFetchRequest";

export const GetGladianceUserRole = async (Ref) => {
  let payload = { GladianceUserRoleRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let resultList = GetMasterTableEntries(td, MasterTableName);
  if (resultList.length > 0) {
    return resultList[0];
  }
  return null;
};

export const SaveGladianceUserRole = async (ref, payload) => {
  payload["Ref"] = await AllocateSingleId(ref);
  return await SaveToServer(payload, MasterTableName, []);
};

export const DeleteGladianceUserRole = async (payload) => {
  return await DeleteFromServer(payload, MasterTableName);
};

export const GetGladianceUserRoleList = async () => {
  let payload = { GladianceUserRoleRefs: [] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  result = result.sort((a, b) => a.Name.localeCompare(b.Name));
  return result;
};
